export const UrlFixer = (relativeUrl) => {
    return process.env.REACT_APP_SERVER_URL + relativeUrl;
}

export const imagePreloader = (imageList) => {
    imageList.forEach((image) => {
        new Image().src = image;
    })
}